import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { campanhaStatusNaoConfirmada, campanhaStatusEmAnalise, campanhaStatusReprovada, campanhaStatusEmAndamento, campanhaStatusEmRevisao, campanhaStatusEncerrada } from '../campanha-status';

@Component({
    selector: 'sgt-campanha-status-multiselect',
    templateUrl: './campanha-status-multiselect.component.html',
    styleUrls: ['./campanha-status-multiselect.component.less']
})
export class CampanhaStatusMultiselectComponent implements OnInit {
    /** status selecionados */
    @Input() statuses: number[];
    /** Ao alterar a seleção dos status */
    @Output() statusesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum status';
    @Input() checked = 'Status'
    @Input() checkedPlural = 'Status';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos selecionados';
    @Input() searchEmptyResult = 'Nenhuma status encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowNaoConfirmada = true;
    @Input() isShowEmAnalise = true;
    @Input() isShowReprovada = true;
    @Input() isShowEmAndamento = true;
    @Input() isShowEmRevisao = true;
    @Input() isShowEncerrada = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-campanha-status ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os status para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowNaoConfirmada) {
            selects.push({
                id: campanhaStatusNaoConfirmada.id,
                name: campanhaStatusNaoConfirmada.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-nao-confirmada'
            });
        }
        if (this.isShowEmAnalise) {
            selects.push({
                id: campanhaStatusEmAnalise.id,
                name: campanhaStatusEmAnalise.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-em-analise'
            });
        }
        if (this.isShowReprovada) {
            selects.push({
                id: campanhaStatusReprovada.id,
                name: campanhaStatusReprovada.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-reprovada'
            });
        }
        if (this.isShowEmAndamento) {
            selects.push({
                id: campanhaStatusEmAndamento.id,
                name: campanhaStatusEmAndamento.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-em-andamento'
            });
        }
        if (this.isShowEmRevisao) {
            selects.push({
                id: campanhaStatusEmRevisao.id,
                name: campanhaStatusEmRevisao.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-em-revisao'
            });
        }
        if (this.isShowEncerrada) {
            selects.push({
                id: campanhaStatusEncerrada.id,
                name: campanhaStatusEncerrada.nome,
                classes: 'multiselect-item-campanha-status multiselect-item-campanha-status-encerrada'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos status */
    onChange() {
        this.statusesChange.emit(this.statuses);
    }
}
